import { useAppSelector } from "@/store/hooks"

export function useSelectedCustomerId() {
  return useAppSelector((state) => state.billingCustomer.selectedCustomerId)
}
